import routePath from '@src/lib/routePath'

const downloadablesPaths = {
  index: routePath(
    '/retailer/downloadables/:retailerAccountSlug/:brandSlug/:parent_id?' as const,
  ),
}

export default downloadablesPaths
